<template id="switch-button">
  <div class="simples-modal" >
    <div class="container">
      <div style="text-align: center; padding-top: 100px">
        <div
          style="
            background-color: #fff;
            padding-top: 22px;
            padding-bottom: 22px;
          "
        >
          <h4 style="color: #000" >
            {{frase}}
          </h4>
          <img src="/img/reload.gif" style="height: 50px" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "reload-v1",
  props: {
    //frase: "Estamos Processando seu envio, Aguarde um momento!",
    frase:{
      type: String,
      default: "Estamos Processando seu envio, Aguarde um momento!",
    }
  },
  methods: {

  },
};
</script>
<style >
.simples-modal {
  position: fixed;
  opacity: 0;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  font-family: Arial, Helvetica, sans-serif;
  background: rgb(29 29 29 / 65%);
  z-index: 99999;
  opacity: 1;
  -webkit-transition: opacity 400ms ease-in;
  transition: opacity 400ms ease-in;
  /*pointer-events: none;*/
}
/*::-webkit-scrollbar {
  width: 12px;
  display:none;
}*/
</style>
